import { AlertType } from "../../types";

interface Props {
    alert: AlertType
}

const Alert: React.FC<Props> = ({ alert }) => {
    return (
        <div aria-label="form-alert"
             className={`border-4 px-4 py-8 rounded-xl flex flex-col gap-4
                      ${ alert.type === "success" 
                         ? "bg-second-solid text-fifth-solid border-first-solid" 
                         : "bg-third-solid text-red-900 border-red-900"}`}>
            <h3 className="text-2xl text-center font-bold">
                {alert.info.title}
            </h3>
            <div className="flex flex-col gap-4">
            {
                alert.info.descriptions.map((description, index) => (
                    <p key={index}
                       className="text-center">
                        {description}
                    </p>
                ))
            }
            </div>
        </div>
    )
}

export default Alert;
